import { useState, useEffect } from 'react';
import defaultConfig from '../config/timing.json';
import { TrackConfigContext } from './track-config-context';

export function TrackConfigProvider({ children }) {
  const [cfg, setCfg] = useState(defaultConfig);

  useEffect(() => {
    fetch('/api/track-config')
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setCfg(data); })
      .catch(() => {});
  }, []);

  return (
    <TrackConfigContext.Provider value={cfg}>
      {children}
    </TrackConfigContext.Provider>
  );
}
